/**
 * Service worker registration.
 *
 * Hot-reload safety: in dev (`localhost` / `NODE_ENV !== 'production'`)
 * we *unregister* any existing SW so devs don't get a stale build.
 * In production we register `/sw.js` (root scope) once on `load`.
 *
 * The SW lives in `public/sw.js` — kept hand-written rather than via
 * Workbox to keep dependencies small (PWA shouldn't drag in 200kb of
 * Workbox runtime for our caching needs).
 */
const IS_LOCAL = ["localhost", "127.0.0.1", ""].includes(
  typeof window !== "undefined" ? window.location.hostname : "",
);

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // In dev, proactively unregister to avoid serving cached production bundles.
  if (process.env.NODE_ENV !== "production" || IS_LOCAL) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister().catch(() => {}));
    });
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Auto-pull an update on first foreground after a deploy.
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              // A new version is ready — let it take over on next nav.
              sw.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.warn("[PWA] SW registration failed", e);
      });
  });
}
